(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-preview-cta"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mobile-preview-cta]').forEach(function (bar) {
    var hero = document.querySelector(bar.getAttribute('data-hero') || '.hh, .ph');
    var destination = document.querySelector(bar.getAttribute('data-target') || '#start');

    function setVisibility() {
      var heroPassed = !hero || hero.getBoundingClientRect().bottom < 80;
      // "In view" means the destination is genuinely on screen — not merely
      // scrolled past. Without the bottom check this bar stays hidden for the
      // whole rest of the page once the form has gone by, leaving a long
      // stretch of testimonials and FAQ with no call to action at all.
      var destinationBox = destination && destination.getBoundingClientRect();
      var destinationVisible =
        !!destinationBox && destinationBox.top < window.innerHeight * 0.82 && destinationBox.bottom > 0;
      bar.classList.toggle('is-visible', heroPassed && !destinationVisible);
    }

    window.addEventListener('scroll', setVisibility, { passive: true });
    window.addEventListener('resize', setVisibility);
    setVisibility();
  });
  } catch(e) { console.error(e); }
})();

})();
